import { useSelector } from 'react-redux';
import { demoUserList } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
var useDemoUser = function () {
    var evolveUsername = useSelector(appSelectors.getEvolveUsername);
    return !!evolveUsername && demoUserList.includes(evolveUsername);
};
export default useDemoUser;
